module.exports = __webpack_public_path__ + "img/ARDR.cddb0a13.svg";